// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"1c72afae","453":"8c817e3c","777":"ac4d778c"}[chunkId] + ".chunk.js";
};